export const joinWords = (...args: any[]) =>
  args
    .map(arg => typeof arg === "string" ? arg.trim() : arg)
    .filter(arg => ![undefined, null, ""].some(notValid => notValid === arg))
    .map(String)
    .join(" ")
